// extracted by css-extract-rspack-plugin
export default {"file":"_file_G5RYc"};